module.exports = {
  en: require("./en"),
  fr: require("./fr"),
  de: require("./de"),
  es: require("./es"),
  it: require("./it"),
  availableLanguages: ["en", "fr", "de", "es", "it"]
};
